import script from "./ExtractionOneUploadModalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtractionOneUploadModalDetail.vue?vue&type=script&setup=true&lang=js"

import "./ExtractionOneUploadModalDetail.vue?vue&type=style&index=0&id=3064273b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3064273b"]])

export default __exports__